import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { CustomPalette } from '@nutrien/cxp-components';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      height: 'calc(100vh - 289px)',
      overflowY: 'auto',
    },
    root1: {
      height: 'calc(100vh - 339px)',
      overflowY: 'auto',
    },
    card: {
      padding: '16px',
    },
    noDeficiencyCard: {
      padding: '8px',
    },
    checkboxes: {
      paddingTop: '25px',
    },
    checkboxLabel: {
      width: '100%',
    },
    photoCardAdd: {
      width: '100px',
      height: '100px',
      border: `1px dashed ${CustomPalette.elevation.dp8}`,
      borderRadius: '4px',
      backgroundColor: CustomPalette.elevation.dp1,
      cursor: 'pointer',
    },
    paper: {
      width: '200px',
      backgroundColor: 'transparent',
    },
    firstAutoComplete: {
      marginTop: '0px',
    },
    riskAssessment: {
      marginTop: '8px',
    },
    requierd: {
      color: '#2AAB3F',
    },
    breakLine: {
      border: '1px solid #FFFFFF0D',
    },
    viewImage: {
      width: '24px',
      height: '-webkit-fill-available',
    },
    componentLocationGrid: {
      width: '100%',
      display: 'inline-flex',
      padding: '2px 16px 2px 16px',
      border: '1px',
      borderRadius: '5px',
      height: 44,
      background: 'rgb(58,58,58)',
    },
    componentLocationPlusButton: {
      verticalAlign: 'middle',
      marginTop: '7px',
      marginLeft: 'auto',
      float: 'right',
      cursor: 'pointer',
    },
    componentInfoDisplay: {
      display: 'flex',
      '& .MuiChip-outlined': {
        border: '1px solid',
        color: '#6CD9C7',
        backgroundColor: 'rgba(39, 126, 126, 0.10)',
        margin: '5px 10px 0 0',
        '& .MuiChip-label': {
          fontSize: '14px',
        },
      },
    },
    outerGrid: {
      padding: '16px',
      marginTop: '16px',
      marginBottom: '1px',
      borderRadius: '10px ',
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      '& .fieldLabel': {
        marginBottom: '8px',
      },
    },
    deleteGrid: {
      padding: '25px 0px 25px 0px',
    },
    deleteText: {
      width: '100%',
      letterSpacing: '0.15px',
    },
    droppleContainer: {
      width: '100%',
    },
    checkboxStyle: {
      marginBottom: 1,
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      marginTop: '16px',
      borderRadius: '10px 10px 10px 10px',
      padding: '16px',
    },
    subtitle: {
      color: '#707070',
      fontStyle: 'normal',
      lineHeight: '20px',
    },
    selectHeight: {
      height: '44px',
    },
    imageBox: {
      backgroundColor: 'rgba(255, 255, 255, 0.09)',
      borderRadius: 4,
    },
    deficiencyCountLabel: {
      fontSize: 30,
      fontWeight: 300,
    },
    searchField: {
      width: 215,
      backgroundColor: '#121212',
    },
    dividerGridContainer: {
      marginLeft: 16,
      marginRight: 16,
      height: 32,
      alignSelf: 'center',
    },
    deficiencyDivider: {
      backgroundColor: 'rgba(255, 255, 255, 0.4)',
    },
    DeficiencyAddButton: {
      width: 'fit-content',
    },
    DeficiencyAddButtonText: {
      fontWeight: 700,
      paddingLeft: 5,
    },
    deficiencyDataGrid: {
      marginTop: 0,
      marginBottom: 45,
    },
    editDefImagesCarouselDragOver: {
      maxHeight: '360px',
      maxWidth: '310px',
      height: '100%',
      width: '100%',
      padding: 8,
      borderRadius: '4px',
    },
    deficiencyInspectorCommentContainer: {
      padding: '16px 16px 0px 16px',
    },
    deficiencyInspectorCommentLabel: {
      fontSize: '30px',
      fontWeight: 300,
    },
    deficiencyFieldLeadCommentsCont: {
      padding: '16px 16px 0px 16px',
    },
    deficiencyFieldLeadCommentsLabel: {
      fontSize: '30px',
      fontWeight: 300,
    },
    deficiencyCancelButton: {
      border: '1px solid rgba(42, 171, 63, 1)',
      borderRadius: '4px',
      height: 44,
    },
    deficiencySaveButton: {
      borderRadius: '4px',
    },
    inspectorAddCommentButton: {
      borderRadius: '4px',
    },
    fieldInspectorCommentsCard: {
      margin: '8px 16px 22px',
      padding: '24px 24px 22px',
    },
    fiCommentsTitle: {
      paddingBottom: '5px',
    },
    fiCommentsTextField: {
      borderRadius: '4px',
      height: '100px',
    },
    liCommentReviewLabel: {
      paddingBottom: '5px',
    },
    liCommentReviewTextField: {
      borderRadius: '4px',
      height: '100px',
    },
    displayToolTip: {
      display: 'contents',
      '& .tooltipLocation': {
        flexFlow: 'wrap',
        backgroundColor: '#212121',
        pointerEvents: 'auto',
        overflowY: 'auto',
        maxHeight: '300px',
        margin: '8px 0px',
        minWidth: '250px',
        maxWidth: 'fit-content',
      },
    },
    tooltip: {
      alignSelf: 'center',
    },
    seeMoreText: {
      display: 'inline-block',
      cursor: 'pointer',
    },
    searchTextField: {
      padding: '0px',
      cursor: 'pointer',
    },
    noDeficiencyFooter: {
      color: 'rgba(255, 255, 255, 0.38)',
    },
    shaftComponentLocationGrid: {
      width: '100%',
      display: 'flex',
      padding: '0px 14px',
      border: '1px',
      borderRadius: '5px',
      height: 44,
      background: 'rgb(58,58,58)',
      '& .firstHorizontalLine': {
        placeSelf: 'center',
        margin: '0px 8px',
      },
      '& .secondHorizontalLine': {
        placeSelf: 'center',
        margin: '0px 16px 0px 8px',
      },
      '& .rangeSelector': {
        width: '53px',
        height: 44,
        backgroundColor: 'rgba(0,0,0,29%)',
        textAlignLast: 'center',
        '& input[type=number]::-webkit-outer-spin-button': {
          '-webkit-appearance': 'none',
          margin: 0,
        },
        '& input[type=number]::-webkit-inner-spin-button': {
          '-webkit-appearance': 'none',
          margin: 0,
        },
        '& .notchedOutline': {
          '&:after': {
            border: 'none',
          },
        },
      },
    },
    cardViewPhotoBox: {
      backgroundImage: (props?: { imageURL?: string }) => `url("${props?.imageURL}")`,
      backgroundSize: 'cover',
    },
    photosCount: {
      flexBasis: 'min-content',
    },
    compoInfoGrid: {
      marginBottom: 20,
    },
    componentGrid: {
      alignSelf: 'normal',
    },
    componentTextField: {
      height: '47px',
    },
    riskAssesmentGrid: {
      marginBottom: 10,
    },
    conditionRating: {
      display: 'flex',
      marginTop: 10,
      marginBottom: 10,
    },
    validateButton: {
      padding: '0px !important',
    },
  }),
);

export default useStyles;
